import { webApi } from '@mi-front/api-clients';
import { useMemo } from 'react';

export type TimelineReportIndex = {
  globalStart: Date;
  globalEnd: Date;
  stationRowsById: Map<string, webApi.StreamQualityPerStationDto>;
};

/**
 * Builds the report time window and a station-id -> per-station row map for timeline rendering.
 */
export function useTimelineReportIndex(
  report: webApi.StreamQualityReportResponseDto,
): TimelineReportIndex {
  return useMemo(() => {
    const start = new Date(report.data.from);
    const end = new Date(report.data.to);
    const map = new Map<string, webApi.StreamQualityPerStationDto>();
    for (const row of report.result.byStation) {
      map.set(row.stationId, row);
    }
    return {
      globalStart: start,
      globalEnd: end,
      stationRowsById: map,
    };
  }, [report]);
}
